'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const react = require('@emotion/react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

function WithDayPickerStyle({ children, size }) {
  return React__namespace.createElement(react.ClassNames, null, ({ css }) => children({
    classNames: {
      body: css`
              display: table-row-group;
            `,
      caption: css`
              margin: 0 0 var(--zds-space-16) 0;
              font: var(--zds-body-4);
              color: var(--zds-text-stronger);
              text-align: center;
            `,
      container: css`
              display: flex;
              justify-content: center;
              position: relative;
              user-select: none;

              &:after,
              &:before {
                border: solid transparent;
                bottom: 100%;
                content: ' ';
                display: block;
                height: 0;
                left: 10%;
                pointer-events: none;
                position: absolute;
                width: 0;
              }

              &:after {
                border-bottom-color: var(--zds-gray-warm-10);
                border-color: rgba(136, 183, 213, 0);
                border-width: 8px;
                margin-left: -8px;
              }

              &:before {
                border-bottom-color: var(--zds-gray-warm-10);
                border-color: rgba(194, 225, 245, 0);
                border-width: 8px;
                margin-left: -8px;
              }

              abbr {
                font: var(--zds-small-print-2);
                text-decoration: none;
              }

              div[role='columnheader'] > abbr {
                font: var(--zds-small-print-4);
                text-transform: uppercase;
              }
            `,
      day: css`
              display: table-cell;
              padding: var(--zds-space-12);
              font: var(--zds-body-1);
              text-align: center;
              vertical-align: middle;
              border: none;
              cursor: pointer;

              &:hover {
                background-color: var(--zds-background-stronger);
                border-radius: var(--zds-radius-large);
              }
            `,
      interactionDisabled: css`
              .DayPicker-Day {
                cursor: default;
              }
            `,
      // @ts-ignore This is valid, but the types don't reflect it: https://react-day-picker.js.org/api/DayPicker/
      month: css`
              border-collapse: collapse;
              border-spacing: 0;
              padding: var(--zds-space-40) var(--zds-space-16)
                var(--zds-space-16) var(--zds-space-0);
              user-select: none;
              ${size !== "small" ? `
                &:last-of-type {
                  border-left: var(--zds-border-weak);
                  padding: var(--zds-space-40) var(--zds-space-0) var(--zds-space-16) var(--zds-space-16);
                }
              ` : ""}
              ${size === "small" && "padding: var(--zds-space-40) var(--zds-space-0) var(--zds-space-16) var(--zds-space-0);"}
            `,
      // @ts-ignore This is valid, but the types don't reflect it: https://react-day-picker.js.org/api/DayPicker/
      months: css`
              display: flex;
            `,
      navBar: "",
      navButtonNext: "",
      navButtonPrev: "",
      navButtonInteractionDisabled: "",
      footer: "",
      todayButton: "",
      week: css`
              display: table-row;
            `,
      weekNumber: "",
      weekday: css`
              display: table-cell;
              padding: var(--zds-space-12);
              font: var(--zds-small-print-4);
              text-align: center;
            `,
      weekdays: css`
              display: table-header-group;

              > div {
                display: table-row;
              }
            `,
      weekdaysRow: "",
      wrapper: css`
              display: flex;
              position: relative;
            `,
      // Modifiers
      outside: css`
              color: var(--zds-stroke-default);
              cursor: default;
            `,
      selected: css`
              background-color: var(--zds-background-selected);
              color: var(--zds-ui-primary-strongest);
              font-weight: 600;
            `,
      today: css`
              color: var(--zds-text-stronger);
              font-weight: 700;
            `,
      disabled: css`
              background-color: var(--zds-background-default);
              color: var(--zds-stroke-stronger);
              cursor: not-allowed;
              outline: none;
            `
    },
    modifiersStyles: {
      from: {
        borderBottomLeftRadius: 10,
        borderTopLeftRadius: 10
      },
      to: {
        borderBottomRightRadius: 10,
        borderTopRightRadius: 10
      }
    }
  }));
}

exports.WithDayPickerStyle = WithDayPickerStyle;
//# sourceMappingURL=WithDayPickerStyle.cjs.js.map
